import apiFetch from '../../apiFetch'

export default function (token, processingAgencyId, docTypeUse) {
  return apiFetch({ endPoint: `ProcessingAgency/${processingAgencyId}/DocTypeUses`, method: 'POST', body: docTypeUse, token: token })
}
